import * as React from "react"
import { useRouteMatch } from "react-router-dom"
import {
  CUSTOMER_PARTY_ROLES,
  VENDOR_PARTY_ROLES,
} from "src/frontend/components/OS/Applications/VendorDirectory/constants"
import routes from "src/frontend/routes"

export function usePartyRoles() {
  const isCustomers = useRouteMatch(routes.customerDirectory.parameterizedPath)

  return React.useMemo(
    () => (isCustomers ? CUSTOMER_PARTY_ROLES : VENDOR_PARTY_ROLES),
    [isCustomers]
  )
}
